import axios from 'axios'

// const api_endpoint = 'https://enterprise.api.docmasweetspot.ca'
// const api_endpoint = 'https://staging.enterprise.api.docmasweetspot.ca'
// const api_endpoint = 'http://127.0.0.1:5001'
const api_endpoint = 'https://fn6mi7qqjd.execute-api.us-east-2.amazonaws.com/dev'
// const api_endpoint = 'https://d6itaje8h6.execute-api.us-east-2.amazonaws.com/prod'


function build_audience(token, project_id){
    let api_url = api_endpoint+'/audience/build_audience';
    let data = {"project_id": project_id};
    return axios_post_call(api_url,data,token);
}

function update_audience(token, payload){
    let api_url = api_endpoint+'/audience/update';
    let data = payload
    return axios_post_call(api_url,data,token);
}

function create_audience(token, payload){
    let api_url = api_endpoint+'/audience/create';
    let data = payload
    return axios_post_call(api_url,data,token);
}  

function delete_audience(token, payload){
    let api_url = api_endpoint+'/audience/delete';
    let data = payload
    return axios_post_call(api_url,data,token);
}

function move_audiences(token, payload){
    let api_url = api_endpoint+'/audience/move_reports';
    let data = payload
    return axios_post_call(api_url,data,token);
}

function fetch_audience(token, payload){
    let api_url = api_endpoint+'/audience/fetch_data';
    let data = payload
    return axios_post_call(api_url,data,token);
}

function fetch_audience_stats(token, payload){
    let api_url = api_endpoint+'/audience/fetch_stats';
    let data = payload
    return axios_post_call(api_url,data,token);
}

function axios_post_call(api_url,data,token){
    return new Promise(function(resolve,reject){
        axios.post(api_url, data, {headers:{Authorization: `Bearer ${token}`}}).then((res)=>{
            if(res.status == 200){
                resolve(res.data);
            }
            else{
                reject();
            }
        }).catch((e)=>{
            reject(api_url+e);
        })
    })
}

export default {
    build_audience,
    update_audience,
    create_audience,
    delete_audience,
    move_audiences,
    fetch_audience,
    fetch_audience_stats
};
